import {MinimumValue} from "../MinimumValue";
import {IsUnique} from "../IsUnique";
import {sprintf} from 'sprintf-js';
import {ValidatorInterface} from "../ValidatorInterface";
import {IModel} from "makerjs";
import CustomDrillHole from "../../CustomDrillHole";
import DrillHole from "../../../Models/DrillHole";
import Length from "../../../../../source/js/shared/models/Geometry/Length";
import AbstractValidatorSet from "./AbstractValidatorSet";
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { CustomDrillHoleMissingValidator } from "../CustomDrillHoleMissingValidator";

export default class CustomDrillHoleValidatorSet extends AbstractValidatorSet {
	private readonly minHoleDiameter: Length;
	private readonly state;
	private readonly customDrillHoles: DrillHole[];
	private readonly parentModel: IModel;
	private readonly combinedShape: IModel;
	private readonly parsed: DrillHole[];

	constructor( minHoleDiameter: Length, state, customDrillHoles: CustomDrillHole[], parentModel: IModel, combinedShape: IModel = null) {
		super();

		this.minHoleDiameter = minHoleDiameter;
		this.state = state;
		this.customDrillHoles = this.mapToInstances( customDrillHoles );
		this.parentModel = parentModel;
		this.combinedShape = combinedShape;

		this.parsed = [];
	}

	mapToInstances( drillHoles ): DrillHole[] {
		return drillHoles.map( hole => {
			return new DrillHole( new Length( hole.x ), new Length( hole.y ), new Length( hole.diameter ) );
		} );
	}

	getValidators(): ValidatorInterface[] {
		const rules = [];
		const { drillHole: drillHoleMessages } = window.measurementSelectorVariables.i18n.validators;

		// Create validation rule for every custom drillhole.
		this.customDrillHoles.forEach( ( hole, index ) => {
			const invalidHole = sprintf( drillHoleMessages.custom.invalid_hole, index + 1 );
			const parsedIds = this.parsed.map( hole => hole.getId() );

			const holeRules = [

				new MinimumValue( {
					field: `drillHoleDiameter_${index + 1}`,
					dimension: `drillHoleDiameter_${index + 1}`,
					value: hole.diameter.in_mm(),
					minimum: this.minHoleDiameter.in_mm(),
					customMessage: `${invalidHole} ${sprintf( drillHoleMessages.diameter.min, this.minHoleDiameter.in_cm_i18n() )}`
				} ),
				new IsUnique( {
					field: `drillHoleUnique_${index + 1}`,
					dimension: `drillHoleUnique_${index + 1}`,
					value: hole.getId(),
					values: parsedIds,
					customMessage: `${invalidHole} ${drillHoleMessages.custom.unique}`
				} ),
				new MaximumDecimalPoints( {
					field: `drillHoleDiameter_${index + 1}`,
					dimension: `drillHoleDiameter_${index + 1}`,
					value: hole.diameter.in_cm(),
					customMessage: sprintf( drillHoleMessages.diameter.decimals, 1 ) } ),
				new MaximumDecimalPoints( {
					field: `drillHoleOffsetX_${index + 1}`,
					dimension: `drillHoleOffsetX_${index + 1}`,
					value: hole.x.in_cm(),
					customMessage: sprintf( drillHoleMessages.custom.decimals.left, 1 ) } ),
				new MaximumDecimalPoints( {
					field: `drillHoleOffsetY_${index + 1}`,
					dimension: `drillHoleOffsetY_${index + 1}`,
					value: hole.y.in_cm(),
					customMessage: sprintf( drillHoleMessages.custom.decimals.bottom, 1 ) } ),
				new CustomDrillHoleMissingValidator(
					this.parentModel,
					this.combinedShape,
					hole.getId(),
					{
						value: hole.getId(),
						field: `drillHoleMissing_${index + 1}`,
						dimension: `drillHoleMissing_${index + 1}`,
					}
				),
			];

			rules.push( ...holeRules );

			this.parsed.push( hole );
		} );

		return rules;
	}
}
